import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";

import { PROPOSED_SELLS_CHAR_COUNT } from "../../../constants";
import { getNamingOverrides } from "../../../helpers";
import { formatDate } from "../../../utils/helpers/chart";

const DataTableRow = ({ name, rows, rowIndex, assetType, reportType }) => {
  if (rows[0].isRowHeader) {
    return (
      <th
        colSpan={rows.length}
        scope="colgroup"
        className="dataTable__cell dataTable__cell-th dataTable__cell-th--row"
      >
        <div>{rows[0].label}</div>
      </th>
    );
  }

  return rows.map((row, i) => {
    let rowLabel =
      row.label !== null
        ? getNamingOverrides(row.label, assetType, reportType, name, "row")
        : "\u2014";
    const profit = row?.profit;

    if (
      name === "proposedSells" &&
      i === 1 &&
      rowLabel.length > PROPOSED_SELLS_CHAR_COUNT
    ) {
      rowLabel = `${rowLabel.substring(
        0,
        PROPOSED_SELLS_CHAR_COUNT - 1
      )}\u2026`;
    }

    if (
      name === "couponCashFlow" &&
      i === 0 &&
      rowLabel.length > 0 &&
      rowLabel !== "Total"
    ) {
      rowLabel = formatDate(rowLabel);
    }

    return i === 0 ? (
      <th
        key={i}
        scope="row"
        className={classnames(
          "dataTable__cell",
          "dataTable__cell-th",
          "dataTable__cell-th--body",
          {
            "dataTable__col--single": rows.length === 2,
            "dataTable__col--double": rows.length === 3,
          }
        )}
      >
        <div className={`dataTable__cell-${rowLabel.replace(/\W/g, "")}`}>
          {rowLabel}
        </div>
      </th>
    ) : (
      <td key={i} className="dataTable__cell dataTable__cell-td">
        <div
          className={classnames("dataTable__cell-card", {
            "dataTable__cell--scenario": row.isCellScenario,
            "dataTable__cell--highlighted": row.isCellHighlighted,
          })}
          data-label={row.label}
        >
          <span>{rowLabel}</span>
          {profit && (
            <span className={`dataTable__cell-card-label-${profit.type}`}>
              {profit.type === "loss" ? `(${profit.value})` : profit.value}
            </span>
          )}
        </div>
      </td>
    );
  });
};

DataTableRow.propTypes = {
  name: PropTypes.string,
  rows: PropTypes.array,
  rowIndex: PropTypes.number,
  assetType: PropTypes.string,
  reportType: PropTypes.string,
};

DataTableRow.defaultProps = {
  rows: [],
};

export default DataTableRow;
